// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fingerprint-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 20V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12V20M16.5 20V12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12V20M12 20V12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Fingerprint1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fingerprint-1',
    ref,
    icon: element,
  },
));

Fingerprint1Icon.displayName = 'Fingerprint1Icon';

export default Fingerprint1Icon;
